export default "__VITE_ASSET__yxxUNER0__"